import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/";
import { PartnerOfferingNewService } from "../_services/partner-offering-new.service";
import { AlertService } from "../_services";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer } from "@angular/platform-browser";
import { EncryptionService } from "../_services/encryption.service";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { SpotlightService } from "../_services/spotlight.service";

class DataTablesResponse {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
  }
  
  class SpotLight {
    id: any;
    name: any;
    image: any;
    status:any;
    description:any;
    designation:any;
    home_display: any;
  }

@Component({
  selector: "app-spotlight",
  templateUrl: "./spotlight.component.html",
})
export class SpotlightComponent implements OnInit {

@Input() allowMultiple: boolean;
  isEditMode: boolean = false;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {}; //  DataTable
  dtTrigger = new Subject(); //  DataTable
  spotlightList: SpotLight[] = [];
  spotlightTotal: any;
  isSubmitted = false;
  selectedToVerticals: any;
  verticals: [];
  fileList: any;
  croppedImage: any = "";
  @Input() fileType: string = ".jpg , .jpeg, .png , .bmp";
  DisplayedText: string = "";
  @Input() required: boolean;
  start: number = 0;
  pageLength: number = 10;
  errorShow: any;
  selectedVerticals: any;
  myVerticals: any;
  isUpdateMode: boolean = false;

  getSpotlight = {
    id: "",
    name: "",
    image: "",
    description:"",
    designation:"",
    home_display: "",
    status:""
  };

  closeResult: string;
  constructor(
    public router: Router,
    private dataService: SpotlightService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private sanitizer: DomSanitizer
  ) {}

  spotlight = {
    id: "",
    name: "",
    image: "",
    description:"",
    designation:"",
    home_display: "",
    status:""
  };

  modalReference: NgbActiveModal;
  modalTitle: string;
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scroll(0, 0);
    this.getSpotlightListing();
    this.loadHide();
 
  }

  getSpotlightListing() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: this.pageLength,
      serverSide: true,
      processing: true,
      order: [[4, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        this.start = dataTablesParameters.start;
        this.pageLength = dataTablesParameters.length;

        this.http
          .post<DataTablesResponse>(
            "/api/get-spotlights",
            {
              req_data: this.enc_dec.encrypt(
                JSON.stringify(Object.assign(dataTablesParameters))
              ),
            },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);
            this.spotlightList = resp.data.map((item: any) => ({
              ...item,
              description: this.truncate(item.description,80),
              created_at : this.formatDate(item.created_at)
            }));

            this.spotlightTotal = resp["recordsTotal"];

            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },
      columns: [
        { data: "id" },
        { data: "name" },
        { data: "designation" },
        { data: "description" },
        { data: "home_display" },
        { data: "status" },
      ],
    };
  }
  

  truncate(value: any, limit: any) {
    if (!value) return "";
    if (value.length > limit) {
      return value.substring(0, limit) + "...";
    }
    return value;
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  open(content) {
    this.croppedImage = "";
    this.isSubmitted = false;
    this.DisplayedText = ''
    if (this.getSpotlight.id != null) {
      this.getSpotlight.id = "";
    }

    this.selectedToVerticals = "";
    this.spotlight.id = "";
    this.spotlight.name = "";
    this.spotlight.description = "";
    this.spotlight.image = "";
    this.spotlight.designation = "";
    this.spotlight.home_display = "Y";
    this.spotlight.status = "Y";

    this.modalTitle = "Add Spotlight";
  this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });   }

 
  save(val, f) {
    this.isSubmitted = true;
    this.isEditMode = !!val.id;

    if (f.form.valid) {
      this.insertAction(val, f);
    } else {
      console.log('error')
    }
   

  }

  edit(id, content) {
    this.isEditMode = true;
    this.fileList = "";
    this.DisplayedText= ''
    this.loadShow();
  
    this.dataService.editSpotlight(id).subscribe((res) => {
      this.getSpotlight = res["spotlights"];
      console.log(res, "editttt");

      this.croppedImage = this.getSpotlight.image;

      this.spotlight = {
        id: this.getSpotlight.id,
        name: this.getSpotlight.name,
        image: this.getSpotlight.image,
        description: this.getSpotlight.description,
        designation: this.getSpotlight.designation,
        home_display: this.getSpotlight.home_display,
        status: this.getSpotlight.status,
      };
      this.loadHide();
      this.modalTitle = "Edit Spotlight";
  this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });     });
  }




formatDate(dateString: string): string {
    const date = new Date(dateString);
    
    const day = String(date.getDate()).padStart(2, '0'); 
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear(); 
    const hours = String(date.getHours()).padStart(2, '0'); 
    const minutes = String(date.getMinutes()).padStart(2, '0'); 
    const seconds = String(date.getSeconds()).padStart(2, '0'); 

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
}


  onFileChange(event: any) {
    this.fileList = event.target.files;
    this.DisplayedText = this.fileList[0].name;
    let hasFile = this.fileList && this.fileList.length > 0;

    if (hasFile) {
        var extension = this.fileList[0].name.substring(
            this.fileList[0].name.lastIndexOf(".")
        ).toLowerCase();

        var validFileTypes = [".jpg", ".jpeg", ".png", ".bmp"];

        if (!validFileTypes.includes(extension)) {
            alert(
                "Please select a valid file type. The supported file types are .jpg, .jpeg, .png, .bmp"
            );
            this.fileList = null;
            this.DisplayedText = '';
            this.croppedImage = ""; 
            this.spotlight.image = ""; 
            return false;
        }

        if (this.fileList[0].size > 5000000) {
            alert("Image size should not be more than 5 MB");
            this.fileList = null;
            this.DisplayedText = '';
            this.croppedImage = ""; 
            this.spotlight.image = ""; 
            return false;
        }

        const reader = new FileReader();
        reader.readAsDataURL(this.fileList[0]);
        reader.onload = () => {
            this.croppedImage = reader.result as string;
            this.spotlight.image = this.croppedImage;
        };

        let multipleFile = this.fileList.length > 1;
        if (!multipleFile) {
            let file: File = this.fileList[0];
        }
      }
    return false;
  }

  insertAction(val, f) {
    let formData: FormData = new FormData();

    formData.append("name", this.spotlight.name);
    formData.append("description", this.spotlight.description);
    formData.append("designation", this.spotlight.designation);
    formData.append("home_display", this.spotlight.home_display);
    formData.append("status", this.spotlight.status);

    if (val.id === "") {
      this.loadShow();
      if (this.fileList) {
        formData.append("image", this.croppedImage);
      }

      this.dataService.save(formData).subscribe(
        (data) => {
          this.loadHide();
          if (data["status"] === 200) {
            this.alertService.success(
              "Spotlight created successfully",
              true
            );

            const table = $("#partneroffertable").DataTable();
            table.ajax.reload(null, false);

            this.modalReference.close();
          }else{
            this.alertService.error(data.msg);
            const modalElement = document.querySelector(".modal");
          if (modalElement) {
            modalElement.scrollTo({ top: 0, behavior: "smooth" });
          }
          }
        },
        (error) => {
          this.loadHide(); // Hide loader on error
          this.alertService.error(error);
        }
      );
    } else {
      this.loadShow();
      formData.append("id", val.id);
      if (this.fileList) {
        formData.append("image", this.croppedImage);
      }

      this.dataService.updateSpotlight(formData).subscribe(
        (data) => {
          this.loadHide();
          if (data["status"] === 200) {
            this.alertService.success(
              "Spotlight updated successfully",
              true
            )
            this.modalReference.close();
            const table = $("#partneroffertable").DataTable();
            table.ajax.reload(null, false);
          }else{
            this.alertService.error(data.msg);
            const modalElement = document.querySelector(".modal");
          if (modalElement) {
            modalElement.scrollTo({ top: 0, behavior: "smooth" });
          }
         }

        },
        (error) => {
          this.loadHide();
          this.alertService.error(error);
        }
      );
    }
  }

  getRowNumber(index: number): number {
    return this.start + index + 1;
  }

  delete(item) {
    this.loadShow();
    //console.log(item.id, "iddddd");

    this.dataService
      .deleteSpotlight(item.id)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            this.alertService.success(
              "Spotlight deleted successfully",
              true
            );
            item.status = item.status === "Y" ? "N" : "Y";
            this.loadHide();
          } else {
            this.alertService.error("Spotlight error");
          }
        },
        (error) => {
          this.alertService.error(error);
        }
      );
    }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
